import * as types from '../constants/actionTypes';

export function assignUserToTask({taskID, userID, quota, status, data} = {}) {
    return { type: types.ASSIGN_USER_TO_TASK, taskID, userID, quota, status, data };
}
export function createUserTask({userTask, status, data} = {}) {
    return { type: types.CREATE_USERTASK, userTask, status, data };
}
export function loadUserTaskByID({userTaskID, status, data} = {}) {
    return { type: types.LOAD_USERTASK_BY_ID, userTaskID, status, data };
}
export function loadUserTasksByUser({userID, status, data} = {}) {
    return { type: types.LOAD_USERTASKS_BY_USER, userID, status, data };
}
export function loadUserTasksByTask({taskID, status, data} = {}) {
    return { type: types.LOAD_USERTASKS_BY_TASK, taskID, status, data };
}
export function loadQuotaHistoryByUserTask({userTaskID, status, data} = {}) {
    return { type: types.LOAD_QUOTA_HISTORY_BY_USER_TASK, userTaskID, status, data };
}
export function pmLoadAllUserTasks({status, data} = {}) {
    return { type: types.PM_LOAD_ALL_USERTASKS, status, data };
}
export function setLoadingFlagForUserTaskState() {
    return { type: types.SET_LOADING_FLAG_FOR_USERTASK_STATE };
}
export function unassignUserFromTask({userTaskID, status, data} = {}) {
    return { type: types.UNASSIGN_USER_FROM_TASK, userTaskID, status, data};
}
export function updateUserTaskAlias({userTaskID, alias, status, data} = {}) {
    return { type: types.UPDATE_USERTASK_ALIAS, userTaskID, alias, status, data };
}
export function updateUserTaskColor({userTask, status, data} = {}) {
    return { type: types.UPDATE_USERTASK_COLOR, userTask, status, data };
}
export function updateUserTaskFavorite({userTask, status, data} = {}) {
    return { type: types.UPDATE_USERTASK_FAVORITE, userTask, status, data };
}
export function updateUserTaskQuota({userTaskID, quota, status, data} = {}) {
    return { type: types.UPDATE_USERTASK_QUOTA, userTaskID, quota, status, data };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/userTaskActions.js
 **/